module.exports = __webpack_public_path__ + "img/7_fineTeam_zsb.46b1df54.png";